export default __webpack_public_path__ + "static/media/diners.e104018b.png";